<div class="videoContainer">
	<div class="quad-grid">
		<div style="aspect-ratio: 16/9">
			<sim-screen-container [cameraLayoutOptionsContainer]="cameraLayoutOptionsContainer" [screenIndex]="0" />
		</div>

		<div style="aspect-ratio: 16/9">
			<sim-screen-container [cameraLayoutOptionsContainer]="cameraLayoutOptionsContainer" [screenIndex]="1" />
		</div>

		<div style="aspect-ratio: 16/9">
			<sim-screen-container [cameraLayoutOptionsContainer]="cameraLayoutOptionsContainer" [screenIndex]="2" />
		</div>

		<div style="aspect-ratio: 16/9">
			<sim-screen-container [cameraLayoutOptionsContainer]="cameraLayoutOptionsContainer" [screenIndex]="3" />
		</div>
	</div>
</div>
